export const CONFIG = 'CONFIG';
export const SET_SIZE = `${CONFIG}/SET_SIZE`;

export const setSize = (width, height) => ({
    type: SET_SIZE,
    width,
    height
});
